import React, { useMemo, useState } from "react";

import { Tooltip } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";

import { Button } from "../../../../../../../../../../components/Form";
import {
  Placeholder,
  Wrapper,
  WrapperPlaceholder,
  WrapperRightSide,
  IconButtonStyled,
  BadgeComponent,
} from "./styles";
import Tag from "./Tag";

interface StorageBoxFieldProps {
  isOnViewMode?: boolean;
  storageBoxes?: string[];
  onAddStorageBox: (view?: boolean) => void;
  disabled?: boolean;
}

export default function StorageBoxField(props: StorageBoxFieldProps) {
  const { storageBoxes = [], onAddStorageBox, isOnViewMode = false, disabled = false } = props;
  const { t: translate } = useTranslation();

  const [moreStorageBoxes, setMoreStorageBoxes] = useState<number>(0);

  const returnStorageBoxes = useMemo(() => {
    if (storageBoxes?.length > 3) {
      const cloneStorageBoxes = _.cloneDeep(storageBoxes);
      const rest = cloneStorageBoxes.splice(3);

      setMoreStorageBoxes(rest.length);

      return cloneStorageBoxes;
    }

    setMoreStorageBoxes(0);

    return storageBoxes;
  }, [storageBoxes]);

  return (
    <Wrapper>
      <WrapperPlaceholder>
        <Placeholder>{translate("storageBox")}</Placeholder>
        <WrapperPlaceholder>
          {returnStorageBoxes?.map((storageBox, index) => (
            <Tag key={`storage-box-tag-${index}`} value={storageBox} />
          ))}

          {moreStorageBoxes > 0 ? (
            <Tooltip title={disabled ? "" : translate("showAllStorageBoxes")} placement="top">
              <div onClick={() => (disabled ? {} : onAddStorageBox(true))}>
                <BadgeComponent badgeContent={`+${moreStorageBoxes}`} />
              </div>
            </Tooltip>
          ) : null}
        </WrapperPlaceholder>
      </WrapperPlaceholder>
      {storageBoxes && storageBoxes?.length > 1 && !isOnViewMode ? (
        <WrapperRightSide>
          <Tooltip title={disabled ? "" : translate("addStorageBox")} placement="top">
            <IconButtonStyled disabled={disabled} onClick={() => onAddStorageBox()}>
              <FiPlus size={16} />
            </IconButtonStyled>
          </Tooltip>
        </WrapperRightSide>
      ) : (
        <React.Fragment>
          {!isOnViewMode ? (
            <Button
              disabled={disabled}
              startIcon={<FiPlus size={16} />}
              onClick={() => onAddStorageBox()}
            >
              {translate("addStorageBox")}
            </Button>
          ) : null}
        </React.Fragment>
      )}
    </Wrapper>
  );
}
